import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
    detail: [],
    detailLoading: false,
    detailError: ''
}

export const fetchMediaCenter = createAsyncThunk("fetchMediaCenter", (params) => {
    return get(params);
});

export const fetchPageData = createAsyncThunk("fetchMediaPage", (params) => {
    return get(params);
});
export const fetchMediaDetail = createAsyncThunk("fetchDataDetail", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'mediacenter',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchMediaCenter.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchMediaCenter.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchMediaCenter.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
        builder.addCase(fetchPageData.pending, (state) => {
            state.loading = true
            state.page_data = []
            state.error = ''
        })
        builder.addCase(fetchPageData.fulfilled, (state, action) => {
            state.loading = false
            state.page_data = action.payload
            state.error = ''
        })
        builder.addCase(fetchPageData.rejected, (state, action) => {
            state.loading = false
            state.page_data = []
            state.error = action.error
        })
        builder.addCase(fetchMediaDetail.pending, (state, action) => {
            state.detailLoading = true
            state.detail = []
            state.detailError = ''
        })
        builder.addCase(fetchMediaDetail.fulfilled, (state, action) => {
            state.detailLoading = false
            state.detail = action.payload
            state.detailError = ''
        })
        builder.addCase(fetchMediaDetail.rejected, (state, action) => {
            state.detailLoading = false
            state.detail = []
            state.detailError = action.error
        })
    }
})


export default postSlice.reducer
